<template>
  <div class="row">
    <div class="col-md-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
    </div>
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab title="Crianças">
          <template #title> <i class="icofont-list"></i> Crianças </template>
          <div class="info-table py-4">
            <div class="info-table-item">
              <Subtitle
                @exibirVermelhos="handleExibirVermelhos"
                @exibirVerdes="handleExibirVerdes"
                :setRed="setRed"
              />
            </div>
            <div class="info-table-item">
              <vue-select
                v-model="selectedFilterBoasPraticasCriancas"
                :options="optionsFilterBoasPraticas"
                label="label"
                placeholder="Boas práticas"
                :clearable="true"
                @input="onChangeFilterBoasPraticas"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="info-table-item">
              <DownloadFiles
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="desenvolvimento-infantil"
              />
            </div>
          </div>
          <TabelaCadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            :selectedFilterBoasPraticas="selectedFilterBoasPraticasCriancas"
            @filterSearch="filterSearch"
            tipo="criancas"
          />
        </b-tab>

        <b-tab title="2 anos">
          <template #title>
            <span style="text-transform: none"
              ><i class="icofont-list"></i> 2 anos</span
            >
          </template>
          <div class="info-table py-4">
            <div class="info-table-item">
              <Subtitle
                @exibirVermelhos="handleExibirVermelhos"
                @exibirVerdes="handleExibirVerdes"
                :setRed="setRed2anos"
              />
            </div>
            <div class="info-table-item">
              <vue-select
                v-model="selectedFilterBoasPraticas2anos"
                :options="optionsFilterBoasPraticas"
                label="label"
                placeholder="Boas práticas"
                :clearable="true"
                @input="onChangeFilterBoasPraticas"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="info-table-item">
              <DownloadFiles
                :callback-pdf="generatePdf"
                :data="displayedCadastros2anos"
                :fields="dataFields"
                name="desenvolvimento-infantil"
              />
            </div>
          </div>
          <TabelaCadastros
            ref="table2anos"
            :cadastros="displayedCadastros2anos"
            :loading="loading"
            :selectedFilterBoasPraticas="selectedFilterBoasPraticas2anos"
            @filterSearch="filterSearch"
            tipo="2anos"
          />
        </b-tab>

        <b-tab title="Percentual">
          <template #title>
            <i class="icofont-mathematical-alt-1"></i> Percentual
          </template>
          <div class="row mt-4">
            <div class="col-md-4">
              <vue-select
                v-model="selectedFilterBoasPraticasTabelaPercentual"
                :options="optionsFilterBoasPraticas"
                label="label"
                placeholder="Boas práticas"
                :clearable="true"
                @input="onChangeFilterBoasPraticasPercentual"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <TabelaPercentual
            :loading="loading"
            :municipio="dadosPercentualMunicipio"
            :equipe="dadosPercentualEquipe"
            :micro_area="dadosPercentualMicroArea"
            :selectedEquipe="equipe"
            :selectedMicroArea="microArea"
            :selectedFilterBoasPraticas="
              selectedFilterBoasPraticasTabelaPercentual
            "
          />
          <GraficoPercentual
            :equipe="equipe"
            :micro_area="microArea"
            ref="graficoPercentual"
          />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Subtitle from './components/Subtitle.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import { dataFields, optionsFilterBoasPraticas } from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastros from './components/TabelaCadastros.vue'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import TabelaPercentual from './components/TabelaPercentual.vue'
import GraficoPercentual from './components/GraficoPercentual.vue'

export default {
  name: 'DesenvolvimentoInfantil',
  components: {
    Subtitle,
    PulseLoader,
    apexchart: VueApexCharts,
    DownloadFiles,
    TitleTag,
    TabelaCadastros,
    SelectsV2,
    TabelaPercentual,
    GraficoPercentual,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      equipe: '',
      microArea: '',
      microAreas: [],
      cadastros: [],
      cadastros2anos: [],
      cadastrosOriginais: [],
      dadosPercentualMunicipio: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosPercentualEquipe: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosPercentualMicroArea: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosTabelaPercentual: [],
      dadosGraficoPercentual: [],
      loading: false,
      tabsActive: 0,
      setRed: false,
      setRed2anos: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      exibirCadastrosVermelhos2anos: false,
      exibirCadastrosVerdes2anos: false,
      filterSearchTable: false,
      filterSearchTable2anos: false,
      dataFields: { ...dataFields },
      selectedFilterBoasPraticasCriancas: null,
      selectedFilterBoasPraticas2anos: null,
      selectedFilterBoasPraticasTabelaPercentual: null,
      optionsFilterBoasPraticas: [...optionsFilterBoasPraticas],
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable) return this.filterSearchTable
      const resultado = Filter.filtro(
        this.cadastros,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes,
        this.selectedFilterBoasPraticasCriancas
      )
      return resultado || []
    },
    displayedCadastros2anos() {
      if (this.filterSearchTable2anos) return this.filterSearchTable2anos
      const resultado = Filter.filtro(
        this.cadastros2anos,
        this.exibirCadastrosVermelhos2anos,
        this.exibirCadastrosVerdes2anos,
        this.selectedFilterBoasPraticas2anos
      )
      return resultado || []
    },
  },
  methods: {
    /**
     * Habilita os filtros vermelho/verde
     *
     * @param {Boolean} vermelho
     * @param {Boolean} verde
     */
    filtros(vermelho, verde) {
      if (this.tabsActive == 0) {
        if (this.$refs.table) this.$refs.table.search = ''
        this.setRed = vermelho
        this.exibirCadastrosVermelhos = vermelho
        this.exibirCadastrosVerdes = verde && !vermelho
      }
      if (this.tabsActive == 1) {
        if (this.$refs.table2anos) this.$refs.table2anos.search = ''
        this.setRed2anos = vermelho
        this.exibirCadastrosVermelhos2anos = vermelho
        this.exibirCadastrosVerdes2anos = verde && !vermelho
      }
    },

    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (this.tabsActive == 0) {
        this.filterSearchTable = item.filter || false
      }
      if (this.tabsActive == 1) {
        this.filterSearchTable2anos = item.filter || false
      }
    },

    /**
     * Atualiza o filtro para exibir registros classificados como vermelhos.
     * @param {Boolean} valor Indica se o filtro deve ser aplicado
     */
    handleExibirVermelhos(valor) {
      this.filtros(valor, false)
    },

    /**
     * Atualiza o filtro para exibir registros classificados como verdes.
     * @param {Boolean} valor Indica se o filtro deve ser aplicado
     */
    handleExibirVerdes(valor) {
      this.filtros(false, valor)
    },

    /**
     * Manipula a alteração da equipe selecionada.
     *
     * @param {Object} event Equipe selecionada
     */
    async onChangeEquipe(event) {
      if (this.tabsActive == 0) {
        if (this.$refs.table) this.$refs.table.search = ''
      }
      if (this.tabsActive == 1) {
        if (this.$refs.table2anos) this.$refs.table2anos.search = ''
      }

      this.equipe = event
      this.microArea = ''
      this.resetDadosMicroArea()

      this.setRed = true
      // this.setRed2anos = true

      if (event) {
        this.resetCadastros()
        await this.buscarCadastrosPorEquipe()
      } else {
        this.resetDadosEquipe()
        this.resetCadastros()
      }

      this.setarPercentualEquipe()
    },

    /**
     * Manipula a alteração da microárea selecionada.
     *
     * @param {Object} event Microárea selecionada
     */
    async onChangeMicroArea(event) {
      if (this.tabsActive == 0) {
        if (this.$refs.table) this.$refs.table.search = ''
      }
      if (this.tabsActive == 1) {
        if (this.$refs.table2anos) this.$refs.table2anos.search = ''
      }
      this.microArea = event?.micro_area || ''
      this.resetDadosMicroArea()

      this.setRed = true
      // this.setRed2anos = true

      if (event && this.microArea) {
        this.loading = true
        await this.buscarCadastrosMicroArea()
        this.loading = false
      } else {
        await this.onChangeEquipe(this.equipe)
      }

      this.setarPercentualMicroArea()
    },

    /**
     * Busca os cadastros por equipe
     */
    async buscarCadastrosPorEquipe() {
      this.loading = true
      const resposta = await Functions.getCadastrosPorEquipe(
        this.$store.state.cod_ibge,
        this.equipe.ine_esf_eap
      )
      if (resposta) {
        this.cadastros = resposta
        this.cadastrosOriginais = resposta
        this.cadastros2anos = resposta.filter((item) => {
          return Number(item.den_desen_infantil_menor_2anos) > 0
        })
        this.filtros(true, false)
      }
      this.loading = false
    },

    /**
     * Busca os cadastros por microárea
     */
    async buscarCadastrosMicroArea() {
      this.loading = true
      const resposta = await Functions.getCadastrosPorMicroArea(
        this.$store.state.cod_ibge,
        this.equipe.ine_esf_eap,
        this.microArea
      )
      if (resposta) {
        this.cadastros = resposta
        this.cadastrosOriginais = resposta
        this.cadastros2anos = resposta.filter((item) => {
          return Number(item.den_desen_infantil_menor_2anos) > 0
        })
        this.filtros(true, false)
      }
      this.loading = false
    },

    /**
     * Manipula ao selecionar uma boa prática
     *
     * @param item
     */
    onChangeFilterBoasPraticas(item) {
      this.handleExibirVermelhos(true)
    },

    /**
     * Manipula ao selecionar uma boa prática na aba percentual
     *
     * @param item
     */
    onChangeFilterBoasPraticasPercentual(item) {
      this.setarPercentualMunicipio()
      if (this.equipe != '') {
        this.setarPercentualEquipe()
      }
      if (this.microArea != '') {
        this.setarPercentualMicroArea()
      }
    },

    /**
     * Calcula e atualiza o percentual do município no gráfico.
     */
    setarPercentualMunicipio() {
      const resultado = Functions.percentualMunicipio(
        this.dadosGraficoPercentual,
        this.selectedFilterBoasPraticasTabelaPercentual
      )
      Object.assign(this.dadosPercentualMunicipio, resultado)
      this.$refs.graficoPercentual.serieHistoricaMunicipio(
        this.dadosGraficoPercentual
      )
    },

    /**
     * Calcula e atualiza o percentual da equipe no gráfico.
     */
    setarPercentualEquipe() {
      const resultado = Functions.percentualEquipe(
        this.dadosGraficoPercentual,
        this.equipe.ine_esf_eap,
        this.selectedFilterBoasPraticasTabelaPercentual
      )
      Object.assign(this.dadosPercentualEquipe, resultado)
      this.$refs.graficoPercentual.serieHistoricaEquipe(
        this.dadosGraficoPercentual,
        this.equipe
      )
    },

    /**
     * Calcula e atualiza o percentual da microárea no gráfico.
     */
    async setarPercentualMicroArea() {
      if (!this.microArea) return
      const resultado = Functions.percentualMicroArea(
        this.dadosGraficoPercentual,
        this.equipe.ine_esf_eap,
        this.microArea,
        this.selectedFilterBoasPraticasTabelaPercentual
      )
      Object.assign(this.dadosPercentualMicroArea, resultado)
      this.$refs.graficoPercentual.serieHistoricaMicroArea(
        this.dadosGraficoPercentual,
        this.equipe,
        this.microArea
      )
    },

    /**
     * Limpa os dados de cadastros da tela.
     */
    resetCadastros() {
      this.cadastros = []
      this.cadastrosOriginais = []
    },

    /**
     * Reseta os dados e percentuais da equipe selecionada.
     */
    resetDadosEquipe() {
      this.equipe = ''
      this.dadosPercentualEquipe = {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      }
    },

    /**
     * Reseta os dados e percentuais da microárea selecionada.
     */
    resetDadosMicroArea() {
      this.dadosPercentualMicroArea = {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      }
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      let dados = []
      let filter = null
      if (this.tabsActive == 0) {
        dados = this.displayedCadastros
        filter = this.selectedFilterBoasPraticasCriancas
      }
      if (this.tabsActive == 1) {
        dados = this.displayedCadastros2anos
        filter = this.selectedFilterBoasPraticas2anos
      }
      Functions.generatePdf(dados, this.equipe, this.microArea, filter)
    },

    /**
     * Inicializa os dados
     */
    async init() {
      try {
        const response2 = await this.$api.get(
          `/app/v2/serie-historica/${this.$store.state.cod_ibge}/indicador/[51]`
        )
        this.dadosGraficoPercentual = response2.data
        this.setarPercentualMunicipio()
        // Enfermeiro, médico ...
        if (this.enableSelect == 2) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
            this.buscarCadastrosPorEquipe()
            this.setarPercentualEquipe()
          }
        }

        // ACS
        if (this.enableSelect == 3) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
            this.setarPercentualEquipe()
          }
          this.microArea = this.$store.state.micro_area
          this.buscarCadastrosMicroArea()
          this.setarPercentualMicroArea()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },

  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style scoped></style>
